import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { DialogData } from 'dg-emp-search-lib';

@Component({
  selector: 'app-dg-reopen-file',
  templateUrl: './dg-reopen-file.component.html',
  styleUrls: ['./dg-reopen-file.component.scss'],
})
export class DgReopenFileComponent implements OnInit {
  str: string;
  fileNo: any;
  caseNo = '';

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<DgReopenFileComponent>
  ) { }
  expForm: FormGroup;
  ngOnInit(): void {
    this.expForm = new FormGroup({
      reason: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^[^#]+$/),
      ]),
    });

  }
  selectedData = [];
  onReopen(): void {
    // let fileid
    if (this.data[0] ?.fileId) { this.onReopentwo(); }
    else { this.onReopenone(); }
  }
  onReopenone(): void {
    this.selectedData.push(this.data);
    console.log(this.selectedData);
    // let selectedDataone = this.selectedData[0].selectedData[0].corrID;
    // let selectedDatatwo = selectedDataone.concat(selectedDataone);
    // selectedDatatwo = selectedDatatwo.concat('~');
    const bodyone = { caseID: this.selectedData[0].selectedData[0].corrID };
    this.http.post<any>('/correspondence-mgmnt/reOpenCorr', bodyone).subscribe((res) => {
      console.log(res);
      // http://localhost:8023/digigov/correspondence-mgmnt/reOpenCorr[0].selectedData[0].corrID

      // Payload - { "caseID": "7106~1234" }
      this.dialogRef.close(true);
      this.caseNo = '';
      console.log('SENT');
    });
    // }
  }
  onReopentwo(): void {
    this.selectedData.push(this.data);
    for (let i = 0; i < 1; i++) {
      for (let j = 0; j < this.selectedData[i].length; j++) {
        this.fileNo = this.selectedData[i][j].fileId;

        if (this.fileNo == undefined) {
          this.fileNo = this.selectedData[i][j].docId;
        }
        if (j != this.selectedData[i].length - 1) {
          this.caseNo = this.caseNo.concat(this.fileNo);
          this.caseNo = this.caseNo.concat('~');
        } else {
          this.caseNo = this.caseNo.concat(this.fileNo);
        }
      }
      const body = { caseID: this.caseNo };
      this.http.put<any>('/case-mgmnt/reopen-case', body).subscribe((res) => {
        console.log(res);
        this.dialogRef.close(true);
      });
      this.caseNo = '';
      console.log('SENT');
    }
  }
  get expFormControl(): FormControl {
    return this.expForm ?.controls.reason as FormControl;
  }
}
